import React from 'react';
import PropTypes from 'prop-types';
import {
  hybridHoldExpiresAt,
  isHybridHoldRunning
} from 'helpers/functionUtils/hybridDelivery';
import useCountdown from 'routes/App/ordersV2/OrderDetails/DriverOptOut/useCountdown';
import HoldCountdownPillWrap from 'routes/App/ordersV2/components/HoldCountdownPill/styles';

const HoldCountdownPill = ({order, serviceFeatures}) => {
  const {seconds, label} = useCountdown(hybridHoldExpiresAt(order));

  const isRunning = isHybridHoldRunning(order, serviceFeatures) && !!seconds;
  if (!isRunning) return null;

  return (
    <HoldCountdownPillWrap>
      Sauce driver assigned in <strong>{label}</strong>
    </HoldCountdownPillWrap>
  );
};

HoldCountdownPill.propTypes = {
  order: PropTypes.shape({}).isRequired,
  serviceFeatures: PropTypes.arrayOf(PropTypes.string)
};

HoldCountdownPill.defaultProps = {
  serviceFeatures: []
};

export default HoldCountdownPill;
